module.exports = __webpack_public_path__ + "img/achievement_35.58de432f.png";